<template>
  <div>
    <TopBar pagetitle="个人信息" back-url="/users/index" />
    <div :model="dataForm" class="whiteForm">
      <van-row>
        <van-col span="6">姓</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.lastName" class="readonly" readonly unselectable="on">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">名</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.firstName" class="readonly" readonly unselectable="on">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">中文姓名</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.localName" placeholder="请输入中文姓名">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">昵 称</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.nickName" placeholder="请输入昵称">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">性别</van-col>
        <van-col span="18" class="input">
          <input v-model="sex" placeholder="请选择性别" readonly unselectable="on" @click="doShowSelect('sex')">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">生    日</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.birthday" placeholder="请输入生日" class="readonly" readonly>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">国 家</van-col>
        <van-col span="18" class="input">
          <input v-model="country" placeholder="请选择国家" readonly unselectable="on" @click="doShowSelect('country')">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">语 言</van-col>
        <van-col span="18" class="input">
          <input v-model="language" placeholder="请选择语言" readonly unselectable="on" @click="doShowSelect('language')">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">城市</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.city" placeholder="请输入城市">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">地址</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.street" placeholder="请输入地址">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">地址</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.street2" placeholder="请输入地址">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">邮编</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.zip" placeholder="请输入邮编">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">单位</van-col>
        <van-col span="18" class="input">
          <input v-model="units" placeholder="请选择单位" readonly @click="doShowSelect('units')">
        </van-col>
      </van-row>
      <!-- <van-row>
        <van-col span="6">手机号码</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.phone" placeholder="请输入手机号" style="width:50%;" maxlength="11">
          <button :class="buttonEnabel?'fontButton':'fontButton getcode'" style="width:6rem;float:right;color:#4a4a4a" @click="sendCode">| {{ sendCodeTitle }}</button>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">验 证 码</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.phoneCode" placeholder="请输入验证码">
        </van-col>
      </van-row> -->

      <van-button type="info" size="large" :loading="editLoading" loading-text="修改中..." @click="edit">修改</van-button>
    </div>
    <van-popup v-model="showSelect" position="bottom">
      <van-picker v-if="showType=='units'" ref="pickerUnits" show-toolbar title="选择单位" :columns="listUnits" @cancel="onCancelPicker" @confirm="onUnits" />
      <van-picker v-if="showType=='sex'" ref="pickerSex" show-toolbar title="选择性别" :columns="listSex" @cancel="onCancelPicker" @confirm="onSex" />
      <van-picker v-if="showType=='country'" ref="pickerCountry" show-toolbar title="选择国家" :columns="listCountry" @cancel="onCancelPicker" @confirm="onCountry" />
      <van-picker v-if="showType=='language'" ref="pickerLanguage" show-toolbar title="选择语言" :columns="listLanguage" @cancel="onCancelPicker" @confirm="onLanguage" />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Field, Button, Checkbox, DatetimePicker, Popup, Dialog, Picker } from 'vant'
import TopBar from '@/components/TopBar'
import { initPage, GetEnumList, formatDate, MyNotify } from '@/utils/base'
import commonData from '@/commondata.js'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Picker.name]: Picker,
    TopBar
  },
  data() {
    return {
      editLoading: false,
      showSelect: false,
      showType: undefined,
      listUnits: [],
      listSex: [],
      listCountry: [],
      listLanguage: [],
      dataForm: {
        localName: undefined,
        nickName: undefined,
        country: undefined,
        language: undefined,
        street: undefined,
        street2: undefined,
        city: undefined,
        zip: undefined,
        units: undefined,
        sex: undefined,
        birthday: undefined,
        lastName: undefined,
        firstName: undefined
      },
      country: undefined,
      language: undefined,
      sex: undefined,
      units: undefined
    }
  },
  created() {
    initPage(false)
    request({
      url: '/user/getUserInfoEdit',
      method: 'post'
    }).then(response => {
      this.readListData()
      this.dataForm = response.data.user
      this.dataForm.birthday = formatDate(this.dataForm.birthday, 'yyyy-MM-dd')
      this.sex = this.listSex.find(item => item.value === this.dataForm.sex).text
      this.units = this.listUnits.find(item => item.value === this.dataForm.units).text
      if (this.dataForm.country != null) {
        this.country = this.listCountry.find(item => item.value === this.dataForm.country.toUpperCase()).text
      }
      if (this.dataForm.language != null) {
        this.language = this.listLanguage.find(item => item.value === this.dataForm.language.toLowerCase()).text
      }
    })
  },
  methods: {
    edit() {
      this.editLoading = true
      request({
        url: '/user/updataUserInfo',
        method: 'post',
        data: this.dataForm
      }).then(response => {
        this.editLoading = false
        if (response.success) {
          MyNotify('success', '修改成功!', 2000)
          this.$router.replace('/users/index')
        }
      })
    },
    readListData() {
      if (this.listUnits.length > 0) {
        return
      }
      this.listUnits = GetEnumList('Em_units')
      this.listSex = GetEnumList('Em_Sex')
      this.listCountry = []
      commonData.ssiBase.COUNTRIES.forEach(item => {
        this.listCountry.push({
          text: item.country,
          value: item.iso3
        })
      })
      this.listLanguage = []
      commonData.ssiBase.LANGUAGES.forEach(item => {
        this.listLanguage.push({
          text: item.name_native,
          value: item.iso3
        })
      })
    },
    doShowSelect(type) {
      this.showSelect = true
      this.showType = type
      setTimeout(() => {
        switch (type) {
          case 'units':
            var index = this.listUnits.findIndex(item => item.value === this.dataForm.units)
            this.$refs.pickerUnits.setIndexes([index])
            break
          case 'sex':
            var index1 = this.listSex.findIndex(item => item.value === this.dataForm.sex)
            this.$refs.pickerSex.setIndexes([index1])
            break
          case 'country':
            if (this.dataForm.country != null) {
              var index2 = this.listCountry.findIndex(item => item.value === this.dataForm.country.toUpperCase())
              this.$refs.pickerCountry.setIndexes([index2])
            }
            break
          case 'language':
            if (this.dataForm.language != null) {
              var index3 = this.listLanguage.findIndex(item => item.value === this.dataForm.language.toLowerCase())
              this.$refs.pickerLanguage.setIndexes([index3])
            }
            break
        }
      }, 1)
    },
    onCancelPicker() {
      this.showSelect = false
      this.showType = undefined
    },
    onUnits() {
      var select = this.$refs.pickerUnits.getValues()
      if (select.length > 0) {
        this.units = select[0].text
        this.dataForm.units = select[0].value
      }
      this.onCancelPicker()
    },
    onSex() {
      var select = this.$refs.pickerSex.getValues()
      if (select.length > 0) {
        this.sex = select[0].text
        this.dataForm.sex = select[0].value
      }
      this.onCancelPicker()
    },
    onCountry() {
      var select = this.$refs.pickerCountry.getValues()
      if (select.length > 0) {
        this.country = select[0].text
        this.dataForm.country = select[0].value
      }
      this.onCancelPicker()
    },
    onLanguage() {
      var select = this.$refs.pickerLanguage.getValues()
      if (select.length > 0) {
        this.language = select[0].text
        this.dataForm.language = select[0].value
      }
      this.onCancelPicker()
    }
  }
}
</script>
